<template>
  <div style="height: 100%;">
    <!--<div id="header">-->
    <!--<HomeHeader></HomeHeader>-->
    <!--</div>-->
    <div id="main" style="width: 100%">
      <div id="center" style="box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); background-color: white;  margin: 0 10px;">
        <div>
          <span>态势地图选择:</span>
          <el-select v-model="mapChoose" @change="drawMap">
            <el-option label="在线态势地图" value="online"></el-option>
            <el-option label="供电态势地图" value="elec"></el-option>
            <el-option label="开机态势地图" value="on"></el-option>
            <el-option label="鸣响态势地图" value="alarm"></el-option>
            <el-option label="回示态势地图" value="return"></el-option>
            <el-option label="巡检态势地图" value="inspect"></el-option>
            <el-option label="维修态势地图" value="repair"></el-option>
          </el-select>
          <el-select v-model="inspectCycle" v-if="mapChoose=='inspect'" style="margin-left:20px" @change="getInspectState">
            <el-option
              v-for="item in CycleTitle"
              :label="item.planTitle"
              :value="item.planningId"
            ></el-option>
          </el-select>
          <el-checkbox v-model="hidePoint" @change="drawMap" style="float: right">隐藏标注</el-checkbox>
        </div>
        <div style="z-index: 100;background-color: white;float:right;position: absolute">
          <div>
            <span v-if="mapChoose=='online'"><el-image :src="require('./icons/在线.png')"></el-image>在线</span>
            <span v-if="mapChoose=='elec'"><el-image :src="require('./icons/供电.png')"></el-image>供电</span>
            <span v-if="mapChoose=='on'"><el-image :src="require('./icons/开机1.png')"></el-image>开机</span>
            <span v-if="mapChoose=='alarm'"><el-image :src="require('./icons/鸣响1.png')"></el-image>低分贝(小于90分贝)</span>
            <span v-if="mapChoose=='return'"><el-image :src="require('./icons/已回示.png')"></el-image>已回示</span>
            <span v-if="mapChoose=='inspect'"><el-image :src="require('./icons/巡检.png')"></el-image>已巡检</span>
            <span v-if="mapChoose=='repair'"><el-image :src="require('./icons/已维修.png')"></el-image>已维修</span>
          </div>
          <div>
            <span v-if="mapChoose=='online'"><el-image :src="require('./icons/离线1.png')"></el-image>离线</span>
            <span v-if="mapChoose=='elec'"><el-image :src="require('./icons/没供电.png')"></el-image>未供电</span>
            <span v-if="mapChoose=='on'"><el-image :src="require('./icons/关机1.png')"></el-image>关机</span>
            <span v-if="mapChoose=='alarm'"><el-image :src="require('./icons/鸣响2.png')"></el-image>高分贝(大于等于90分贝)</span>
            <span v-if="mapChoose=='return'"><el-image :src="require('./icons/未回示.png')"></el-image>未回示</span>
            <span v-if="mapChoose=='inspect'"><el-image :src="require('./icons/巡检1.png')"></el-image>未巡检</span>
            <span v-if="mapChoose=='repair'"><el-image :src="require('./icons/待维修.png')"></el-image>待维修</span>
          </div>
          <div>
            <span v-if="mapChoose=='return'"><el-image :src="require('./icons/故障.png')"></el-image>故障</span>
          </div>
        </div>

        <div id="cityMap" style="width: 100%;height: 100%;position: absolute">

<!--            <el-card style="position: absolute; left: 60px; top: 20px; z-index: 100; background-color: rgba(50%,50%,50%,0.5)">-->

<!--              <el-button @click="changeSearchDisplay">-->
<!--                <span v-if="!show_search_in_map"><i class="el-icon-arrow-down"></i>展开查询</span>-->
<!--                <span v-else><i class="el-icon-arrow-up"></i>收起查询</span>-->
<!--              </el-button>-->
<!--              <transition name="el-zoom-in-top" >-->
<!--                <el-form class="search_in_map" v-show="show_search_in_map" :label-position="labelPosition">-->
<!--                  <el-form-item>-->
<!--                    <template slot="label">-->
<!--                      <span>区域</span>-->
<!--                    </template>-->
<!--                    <el-cascader v-model="GetMapInformation.params.areaId" :options="areaList.result.areaList" clearable-->
<!--                                 @click.native="getAreaList" style="width: 100%" filterable></el-cascader>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item >-->
<!--                    <template slot="label">-->
<!--                      <span>时间</span>-->
<!--                    </template>-->
<!--                    <el-date-picker-->
<!--                      v-model="timeRange"-->
<!--                      type="daterange"-->
<!--                      unlink-panels-->
<!--                      align="right"-->
<!--                      range-separator="至"-->
<!--                      start-placeholder="开始日期"-->
<!--                      end-placeholder="结束日期"-->
<!--                      :picker-options="pickerOptions"-->
<!--                      value-format="yyyyMMdd">-->
<!--                    </el-date-picker>-->
<!--&lt;!&ndash;                    :picker-options="pickerOptions"&ndash;&gt;-->
<!--&lt;!&ndash;                    unlink-panels&ndash;&gt;-->
<!--                  </el-form-item>-->
<!--                  <el-form-item >-->
<!--                    <template slot="label">-->
<!--                      <span>主题</span>-->
<!--                    </template>-->
<!--                    <el-select v-model="GetMapInformation.params.state" style="width:100%">-->
<!--                      <el-option label="巡检" :value="1"></el-option>-->
<!--                      <el-option label="告警" :value="2"></el-option>-->
<!--                      <el-option label="异常" :value="3"></el-option>-->
<!--                    </el-select>-->
<!--                  </el-form-item>-->
<!--                  <el-form-item>-->
<!--                    <el-button type="primary" icon="el-icon-search" @click="getMapInformation">查询</el-button>-->
<!--                  </el-form-item>-->
<!--                </el-form>-->
<!--              </transition>-->
<!--            </el-card>-->
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from './homeComponents/HomeHeader'
import HomeLeftOne from './homeComponents/HomeLeftOne'
import HomeLeftTwo from './homeComponents/HomeLeftTwo'
import HomeLeftThree from './homeComponents/HomeLeftThree'
import HomeRightOne from './homeComponents/HomeRightOne'
import HomeRightTwo from './homeComponents/HomeRightTwo'
import HomeRightThree from './homeComponents/HomeRightThree'
import HomeMap from './homeComponents/HomeMap'
import elec1 from './icons/供电.png'
import elec2 from './icons/没供电.png'
import online1 from './icons/在线.png'
import online2 from './icons/离线1.png'
import on1 from './icons/开机1.png'
import on2 from './icons/关机1.png'
import alarm1 from './icons/鸣响1.png'
import alarm2 from './icons/鸣响2.png'
import inspect1 from './icons/巡检.png'
import inspect2 from './icons/巡检1.png'
import repair1 from './icons/已维修.png'
import repair2 from './icons/待维修.png'
import return1 from './icons/已回示.png'
import return2 from './icons/未回示.png'
import return3 from './icons/故障.png'
var fun= function () {
  console.log('hello');
}
export default {
  name: 'BigScreen',
  components: { HomeMap, HomeRightThree, HomeRightTwo, HomeRightOne, HomeLeftThree, HomeLeftTwo, HomeLeftOne, HomeHeader },
  data(){
    const self = this;
    return {
      map:'',
      websocket:null,
      inspectCycle:'',
      GetCycleTitleInfo:{//发送获取规划主题下拉框请求
        "version":1,
        "method":"distribution.GetPlanningTitle",
        "params":null,
        "token":"#",
        "id":0
      },
      inspectDevice:'',
      repairDevice:'',
      GetInspectState:{
        "version": 1,
        "method": "map.MapEquInspect",
        "params": {
	      "planningId":""
        },
        "token": "#",
        "id": 0
      },
      GetRepairState:{
        "version": 1,
        "method": "map.MapEquRepair",
        "params": {},
        "token": "#",
        "id": 0
      },
      CycleTitle:'',
      markerList:[],
      markerHash:{},
      realMapShow: false,
      hidePoint:false,
      mapChoose:'online',
      token:'',
      // 地图信息请求
      GetMapInformation:{
        "version": 1,
        "method": "map.MapEquSta",
        "params": {},
        "token": "#",
        "id": 0
      },
      GetStateCode:{//获取回示状态
        "version": 1,
        "method": "map.MapEquAlaem",
        "params": {},
        "token": "#",
        "id": 0
  },
      // 警报点列表
      alarmPointList:{},
      // 获取区域列表
      GetAreaList:{
        "version": 1,
        "method": "area.GetAreaList",
        "params": null
        ,
        "token": "",
        "id": 0
      },
      // 区域列表
      areaList:{
        "version": 1,
        "result":{
          "areaList": [
            {
              "areaId": "",
              "label": "",
              "childList":[],
            },
          ]
        },
        "id": 0
      },
      labelPosition:'top',
      show_search_in_map:false,
      timeRange:'',// 时间范围
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      // *****地图相关**********
      longitude:0,//经度
      latitude:0,//纬度
      city:'',
      // *****地图相关***********
      SystemStatistics:{
        "version": 1,
        "result": {
          "pointNum":100, // 警报点总数
          "alertedPointNum":1, // 发出警告警报点数(字段待修复)
          "breakdownPointNum":1, // 发生故障未修复警报点数
          "repairedPointNum":1, // 发生故障并修复的警报点数
          "alarmTypeCountList":[  // 告警类型统计
            {"alarmType":"电压过高", // 告警类型
              "count":"" // 个数
            },{"alarmType":"电流过载", "count":""
            },{"alarmType":"温度过高", "count":""
            },{"alarmType":"噪声过大", "count":""
            },{"alarmType":"空气污染", "count":""
            },
          ],
          // "alarmRecordCountArray":{int,int,...}      //size = 5
        },
        "id": 0
      },
    }
  },
  methods: {
    getCycleTitle(){//获取巡检规划表中的规划主题
      //this.GetCycleTitleInfo.token = this.$store.state.token;
      this.$axios.post(this.$mainUrl,this.GetCycleTitleInfo).then(res=>{
        if(res.data.hasOwnProperty('result')) {
          this.CycleTitle = res.data.result.planTitleList
          //this.inspectCycle = res.data.result.planTitleList[0].planningId;
          this.getCyclePoint();
          // this.getCycleTime();

        }
      })
    },
    getInspectState(){//获取某个巡检周期内的设备
      this.GetInspectState.params.planningId = this.inspectCycle;
      for (let key in this.GetInspectState.params){
        if(this.GetInspectState.params[key] === ""){
          this.GetInspectState.params[key] = null
        }
      }
      this.$axios.post(this.$mainUrl,this.GetInspectState).then(res=>{
        if(res.data.hasOwnProperty('result')){
          this.inspectDevice = res.data.result
          this.drawMap(this)
        }
      })
    },
    getHomeMapFeedBack(realMapShow){
      console.log(realMapShow);
      this.realMapShow = realMapShow;
    },
    // 获取地图上警报点列表
    getMapInformation(){
      console.log('获取地图上的警报点请求');
      console.log(this.GetMapInformation);
      this.GetMapInformation.token = this.$store.state.token;
      for (let key in this.GetMapInformation.params){
        if(this.GetMapInformation.params[key] === ""){
          this.GetMapInformation.params[key] = null
        }
      }
      // if(this.GetMapInformation.params.areaId !== null){
      //   this.GetMapInformation.params.areaId = this.GetMapInformation.params.areaId[this.GetMapInformation.params.areaId.length-1];
      // }
      this.$axios.post(this.$mainUrl, this.GetMapInformation).then(res=>{
        console.log('获取地图上的警报点请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message: '获取警报点地图信息成功',
          })
          //alert(JSON.stringify(res.data.result))
          this.alarmPointList = res.data.result;

          this.drawMap(this);
        }else{
          this.$message({
            type:'error',
            message: '获取警报点地图信息失败，' + res.data.error.message,
          })
        }
      })
    },
    changeSearchDisplay(){
      this.show_search_in_map = !this.show_search_in_map
    },
    //定位获得当前位置信息
    getMyLocation() {
      var geolocation = new qq.maps.Geolocation("EEKBZ-B6TKW-7RQRF-OMO44-A2RFK-6NBVJ", "人防预警");
      geolocation.getIpLocation(this.showPosition, this.showErr);
    },
    // 获取区域列表
    getAreaList(){
      this.GetAreaList.token = this.$store.state.token;
      console.log('获取区域列表请求');
      console.log(this.GetAreaList);
      this.$axios.post(this.$mainUrl, this.GetAreaList).then(res=>{
        console.log('获取区域列表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          let areaList = JSON.stringify(res.data);
          areaList  = areaList.replace(/childList/g, 'children');
          areaList  = areaList.replace(/areaName/g, 'label');
          areaList  = areaList.replace(/areaId/g, 'value');
          areaList = JSON.parse(areaList);
          console.log('areaList');
          console.log(areaList);
          this.areaList = areaList;
        }else{
          this.$message({
            type: 'error',
            message: '获取区域列表失败，' + res.data.error.message
          })
        }
      })
    },
    showPosition(position) {
      console.log(position);
      this.latitude = position.lat;
      this.longitude = position.lng;
      this.city = position.city;
      // this.setMap();
    },
    getStatus(status){
      if(status === 0){
        return '正常';
      }else if(status === 1){
        return '故障';
      }else{
        return;
      }
    },
    initMap(){
      document.getElementById('cityMap').innerHTML = ''
      let map;
      map = new AMap.Map('cityMap', {
        resizeEnable: true,
        center: [119.919606016,32.4760532748],
        zoom: 12,
      });
      this.map = map;
      //return map;
    },

    drawMap(self) {
      let alarmPointKey = Object.keys(this.alarmPointList);
      let markerList = this.markerList;
      let pic;
      let map = this.map;
      if(this.hidePoint =='1'){
        map.setFeatures(['bg','road','building']);
      }else{
        map.setFeatures(['bg','road','building','point']);
      }
      //高德地图
      // document.getElementById('cityMap').innerHTML = ''
      // let map;
      // map = new AMap.Map('cityMap', {
      //   resizeEnable: true,
      //   center: [117.000923, 36.675807],
      //   zoom: 12,
      // });


      let infoWin = new AMap.InfoWindow({
        offset:{ x: 0, y: -32 },
        showShadow:true,
      });
      if(this.mapChoose=='online'){
        let alarmPointList = this.alarmPointList;
        let markerList = this.markerList
        let markerHash = this.markerHash;
        map.remove(markerList)
        alarmPointKey.forEach((item) =>{
          (function(){
            if(alarmPointList[item]['latitude'] ==null||alarmPointList[item]['latitude'] ==''||alarmPointList[item]['longitude']==null||alarmPointList[item]['longitude']==''){
              return;
            }
            if(alarmPointList[item]['online'] == true){
              pic = online1;
            }else{
              pic = online2
            }
            let marker = new AMap.Marker({
              position: [alarmPointList[item]['longitude'],alarmPointList[item]['latitude']],
              icon:pic,
              extData:{"id":"1"}
              //animation:qq.maps.MarkerAnimation.DROP
            })
            //alert(JSON.stringify(marker.getExtData().id))
            markerHash[item] = marker;
            markerList.push(marker)
            marker.setMap(map);
            // this.markerList.push(marker);
            // alert(this.markerList.toString())
            AMap.event.addListener(marker, 'click', function() {
              localStorage.setItem('alarmPointId',item.pointName);
              //infoWin.setPosition(center);
              // infoWin.setContent('<div><p class="makerLabel">警报点名称:</p>${item.pointName}</div> <div><p class="makerLabel">所属区域Id:</p>${item.areaId}</div> <div><a href="/#/realTimeData?alarmPointId=${item._id}" target="_blank">详情</a></div>');
              infoWin.setContent(`<div style="background-color: white;width: 200px"><p class="makerLabel">警报点名称:</p>${alarmPointList[item]['pointName']}</div>
                               <div style="background-color: white;width: 200px"><p class="makerLabel">所属区域:</p>${alarmPointList[item]['areaName']}</div>
                                 <div style="background-color: white;width: 200px"><a href="/#/realTimeData?alarmPointId=${item}" target="_blank">详情</a></div>`);
              infoWin.open(map,marker.getPosition())

            });

          })();
        })
        this.markerHash = markerHash;
        // setTimeout(function () {
        //   markerHash['60483a723cdbe87a9ca9b946'].setIcon(repair2)
        // },5000)

      };


      if(this.mapChoose=='elec'){
        let alarmPointList = this.alarmPointList;
        let markerList = this.markerList
        let markerHash = this.markerHash;
        map.remove(markerList)
        alarmPointKey.forEach((item) =>{
          (function(){
            if(alarmPointList[item]['latitude'] ==null||alarmPointList[item]['latitude'] ==''||alarmPointList[item]['longitude']==null||alarmPointList[item]['longitude']==''){
              return;
            }
            if(alarmPointList[item]['CE'] == true){
              pic = elec1;
            }else{
              pic = elec2
            }
            let marker = new AMap.Marker({
              position: [alarmPointList[item]['longitude'],alarmPointList[item]['latitude']],
              icon:pic,
              extData:{"id":"1"}
              //animation:qq.maps.MarkerAnimation.DROP
            })
            markerHash[item] = marker;
            markerList.push(marker);
            marker.setMap(map);
            // this.markerList.push(marker);
            // alert(this.markerList.toString())
            AMap.event.addListener(marker, 'click', function() {
              localStorage.setItem('alarmPointId',item.pointName);
              //infoWin.setPosition(center);
              // infoWin.setContent('<div><p class="makerLabel">警报点名称:</p>${item.pointName}</div> <div><p class="makerLabel">所属区域Id:</p>${item.areaId}</div> <div><a href="/#/realTimeData?alarmPointId=${item._id}" target="_blank">详情</a></div>');
              infoWin.setContent(`<div style="background-color: white;width: 200px"><p class="makerLabel">警报点名称:</p>${alarmPointList[item]['pointName']}</div>
                               <div style="background-color: white;width: 200px"><p class="makerLabel">所属区域:</p>${alarmPointList[item]['areaName']}</div>
                                 <div style="background-color: white;width: 200px"><a href="/#/realTimeData?alarmPointId=${item}" target="_blank">详情</a></div>`);
              infoWin.open(map,marker.getPosition( ))

            });

          })();
        })
        this.markerList = markerList;
      };

      if(this.mapChoose=='on'){
        let alarmPointList = this.alarmPointList;
        let markerList = this.markerList
        let markerHash = this.markerHash;
        map.remove(markerList)
        alarmPointKey.forEach((item) =>{
          (function(){
            if(alarmPointList[item]['latitude'] ==null||alarmPointList[item]['latitude'] ==''||alarmPointList[item]['longitude']==null||alarmPointList[item]['longitude']==''){
              return;
            }
            if(alarmPointList[item]['on'] == true){
              pic = on1;
            }else{
              pic = on2
            }
            let marker = new AMap.Marker({
              position: [alarmPointList[item]['longitude'],alarmPointList[item]['latitude']],
              icon:pic,
              extData:{"id":"1"}
              //animation:qq.maps.MarkerAnimation.DROP
            })
            markerHash[item] = marker;
            markerList.push(marker);
            marker.setMap(map);
            // this.markerList.push(marker);
            // alert(this.markerList.toString())
            AMap.event.addListener(marker, 'click', function() {
              localStorage.setItem('alarmPointId',item.pointName);
              //infoWin.setPosition(center);
              // infoWin.setContent('<div><p class="makerLabel">警报点名称:</p>${item.pointName}</div> <div><p class="makerLabel">所属区域Id:</p>${item.areaId}</div> <div><a href="/#/realTimeData?alarmPointId=${item._id}" target="_blank">详情</a></div>');
              infoWin.setContent(`<div style="background-color: white;width: 200px"><p class="makerLabel">警报点名称:</p>${alarmPointList[item]['pointName']}</div>
                               <div style="background-color: white;width: 200px"><p class="makerLabel">所属区域:</p>${alarmPointList[item]['areaName']}</div>
                                 <div style="background-color: white;width: 200px"><a href="/#/realTimeData?alarmPointId=${item}" target="_blank">详情</a></div>`);
              infoWin.open(map,marker.getPosition( ))

            });

          })();
        })
        this.markerList = markerList;
      };

      if(this.mapChoose=='alarm'){
        let alarmPointList = this.alarmPointList;
        let markerList = this.markerList
        let markerHash = this.markerHash;
        map.remove(markerList)
        alarmPointKey.forEach((item) =>{
          (function(){
            if(alarmPointList[item]['latitude'] ==null||alarmPointList[item]['latitude'] ==''||alarmPointList[item]['longitude']==null||alarmPointList[item]['longitude']==''){
              return;
            }
            if(alarmPointList[item]['alarm'] >=90){
              pic = alarm1;
            }else{
              pic = alarm2
            }
            let marker = new AMap.Marker({
              position: [alarmPointList[item]['longitude'],alarmPointList[item]['latitude']],
              icon:pic,
              extData:{"id":"1"}
              //animation:qq.maps.MarkerAnimation.DROP
            })
            markerHash[item] = marker;
            markerList.push(marker);
            marker.setMap(map);
            // this.markerList.push(marker);
            // alert(this.markerList.toString())
            AMap.event.addListener(marker, 'click', function() {
              localStorage.setItem('alarmPointId',item.pointName);
              //infoWin.setPosition(center);
              // infoWin.setContent('<div><p class="makerLabel">警报点名称:</p>${item.pointName}</div> <div><p class="makerLabel">所属区域Id:</p>${item.areaId}</div> <div><a href="/#/realTimeData?alarmPointId=${item._id}" target="_blank">详情</a></div>');
              infoWin.setContent(`<div style="background-color: white;width: 200px"><p class="makerLabel">警报点名称:</p>${alarmPointList[item]['pointName']}</div>
                               <div style="background-color: white;width: 200px"><p class="makerLabel">所属区域:</p>${alarmPointList[item]['areaName']}</div>
                                 <div style="background-color: white;width: 200px"><a href="/#/realTimeData?alarmPointId=${item}" target="_blank">详情</a></div>`);
              infoWin.open(map,marker.getPosition( ))

            });

          })();
        })
        this.markerList = markerList;
      };


      if(this.mapChoose=='return'){
        let markerList = this.markerList
        let markerHash = this.markerHash;
        this.$axios.post(this.$mainUrl,this.GetStateCode).then(res=>{
          if(res.data.hasOwnProperty('result')){
            let alarmStateKey = Object.keys(res.data.result);
            let alarmState = res.data.result
            map.remove(markerList)
            alarmStateKey.forEach((item) =>{
              (function(){
                if(alarmState[item]['latitude'] ==null||alarmState[item]['latitude'] ==''||alarmState[item]['longitude']==null||alarmState[item]['longitude']==''){
                  return;
                }
                if(alarmState[item]['flag'] ==true){
                  if(alarmState[item]['stateCode'] == '00'){
                    pic = return1;
                  }else{
                    pic = return3;
                  }
                }else{
                  pic = return2
                }
                let marker = new AMap.Marker({
                  position: [alarmState[item]['longitude'],alarmState[item]['latitude']],
                  icon:pic,
                  extData:{"id":"1"}
                  //animation:qq.maps.MarkerAnimation.DROP
                })
                markerHash[item] = marker;
                markerList.push(marker);
                marker.setMap(map);
                // this.markerList.push(marker);
                // alert(this.markerList.toString())
                AMap.event.addListener(marker, 'click', function() {
                  localStorage.setItem('alarmPointId',item.pointName);
                  //infoWin.setPosition(center);
                  // infoWin.setContent('<div><p class="makerLabel">警报点名称:</p>${item.pointName}</div> <div><p class="makerLabel">所属区域Id:</p>${item.areaId}</div> <div><a href="/#/realTimeData?alarmPointId=${item._id}" target="_blank">详情</a></div>');
                  infoWin.setContent(`<div style="background-color: white;width: 200px"><p class="makerLabel">警报点名称:</p>${alarmState[item]['pointName']}</div>
                               <div style="background-color: white;width: 200px"><p class="makerLabel">所属区域:</p>${alarmState[item]['areaName']}</div>
                                 <div style="background-color: white;width: 200px"><a href="/#/realTimeData?alarmPointId=${item}" target="_blank">详情</a></div>`);
                  infoWin.open(map,marker.getPosition( ))

                });

              })();
            })
          }
        })
        this.markerList = markerList;
      };


      if(this.mapChoose=='inspect'){
        let alarmPointKey = Object.keys(this.inspectDevice)
        let alarmPointList = this.inspectDevice;
        map.remove(markerList)
        alarmPointKey.forEach((item) =>{
          (function(){
            if(alarmPointList[item]['latitude'] ==null||alarmPointList[item]['latitude'] ==''||alarmPointList[item]['longitude']==null||alarmPointList[item]['longitude']==''){
              return;
            }
            if(alarmPointList[item]['inspect'] ==true){
              pic = inspect1;
            }else{
              pic = inspect2
            }
            let marker = new AMap.Marker({
              position: [alarmPointList[item]['longitude'],alarmPointList[item]['latitude']],
              icon:pic,
              extData:{"id":"1"}
              //animation:qq.maps.MarkerAnimation.DROP
            })
            markerList.push(marker);
            marker.setMap(map);
            // this.markerList.push(marker);
            // alert(this.markerList.toString())
            AMap.event.addListener(marker, 'click', function() {
              localStorage.setItem('alarmPointId',item.pointName);
              //infoWin.setPosition(center);
              // infoWin.setContent('<div><p class="makerLabel">警报点名称:</p>${item.pointName}</div> <div><p class="makerLabel">所属区域Id:</p>${item.areaId}</div> <div><a href="/#/realTimeData?alarmPointId=${item._id}" target="_blank">详情</a></div>');
              infoWin.setContent(`<div style="background-color: white;width: 200px"><p class="makerLabel">警报点名称:</p>${alarmPointList[item]['pointName']}</div>
                               <div style="background-color: white;width: 200px"><p class="makerLabel">所属区域:</p>${alarmPointList[item]['areaName']}</div>
                                 <div style="background-color: white;width: 200px"><a href="/#/realTimeData?alarmPointId=${item}" target="_blank">详情</a></div>`);
              infoWin.open(map,marker.getPosition( ))

            });

          })();
        })
        this.markerList = markerList;
      };

      if(this.mapChoose=='repair'){
        this.$axios.post(this.$mainUrl,this.GetRepairState).then(res=>{
          if(res.data.hasOwnProperty('result')){
            this.repairDevice = res.data.result
            let alarmPointKey = Object.keys(this.repairDevice)
            let alarmPointList = this.repairDevice;
            map.remove(markerList)
            alarmPointKey.forEach((item) =>{
              (function(){
                if(alarmPointList[item]['latitude'] ==null||alarmPointList[item]['latitude'] ==''||alarmPointList[item]['longitude']==null||alarmPointList[item]['longitude']==''){
                  return;
                }
                if(alarmPointList[item]['repair'] ==true){
                  pic = repair1;
                }else{
                  pic = repair2
                }
                let marker = new AMap.Marker({
                  position: [alarmPointList[item]['longitude'],alarmPointList[item]['latitude']],
                  icon:pic,
                  extData:{"id":"1"}
                  //animation:qq.maps.MarkerAnimation.DROP
                })
                markerList.push(marker);
                marker.setMap(map);
                // this.markerList.push(marker);
                // alert(this.markerList.toString())
                AMap.event.addListener(marker, 'click', function() {
                  localStorage.setItem('alarmPointId',item.pointName);
                  //infoWin.setPosition(center);
                  // infoWin.setContent('<div><p class="makerLabel">警报点名称:</p>${item.pointName}</div> <div><p class="makerLabel">所属区域Id:</p>${item.areaId}</div> <div><a href="/#/realTimeData?alarmPointId=${item._id}" target="_blank">详情</a></div>');
                  infoWin.setContent(`<div style="background-color: white;width: 200px"><p class="makerLabel">警报点名称:</p>${alarmPointList[item]['pointName']}</div>
                               <div style="background-color: white;width: 200px"><p class="makerLabel">所属区域:</p>${alarmPointList[item]['areaName']}</div>
                                 <div style="background-color: white;width: 200px"><a href="/#/realTimeData?alarmPointId=${item}" target="_blank">详情</a></div>`);
                  infoWin.open(map,marker.getPosition( ))

                });

              })();
            })
            this.markerList = markerList;
          }
        })

      };




      // this.alarmPointList.result.alarmPointList.forEach((item) =>{
      //   (function(){
      //     if(item.latitude ==null||item.latitude ==''||item.longitude==null||item.longitude==''){
      //       return;
      //     }
      //     let marker = new AMap.Marker({
      //       position: [item.longitude,item.latitude],
      //       icon:elec1,
      //       extData:{"id":"1"}
      //       //animation:qq.maps.MarkerAnimation.DROP
      //     });
      //     marker.setMap(map);
      //     // this.markerList.push(marker);
      //     // alert(this.markerList.toString())
      //     AMap.event.addListener(marker, 'click', function() {
      //       localStorage.setItem('alarmPointId',item.pointName);
      //       //infoWin.setPosition(center);
      //       // infoWin.setContent('<div><p class="makerLabel">警报点名称:</p>${item.pointName}</div> <div><p class="makerLabel">所属区域Id:</p>${item.areaId}</div> <div><a href="/#/realTimeData?alarmPointId=${item._id}" target="_blank">详情</a></div>');
      //       infoWin.setContent(`<div style="background-color: white;width: 200px"><p class="makerLabel">警报点名称:</p>${item.pointName}</div>
      //                          <div style="background-color: white;width: 200px"><p class="makerLabel">所属区域Id:</p>${item.areaId}</div>
      //                            <div style="background-color: white;width: 200px"><a href="/#/realTimeData?alarmPointId=${item._id}" target="_blank">详情</a></div>`);
      //       infoWin.open(map,marker.getPosition( ))
      //
      //     });
      //
      //   })();
      // })

      //原版腾讯地图
      // var originalCenter = new qq.maps.LatLng(36.675807,117.000923);
      // var map = new qq.maps.Map(document.getElementById("cityMap"), {
      //   zoom:12,//设置地图缩放级别
      //   center: originalCenter,//设置地图中心点坐标
      //   baseMap: {
      //     type: 'vector',
      //     features: ['base', 'building3d']  // 隐藏矢量文字
      //   }
      // });
      // // var map = new qq.maps.Map(document.getElementById("cityMap"), {
      // //   // center: originalCenter,
      // //   // zoom: 12,
      // //   baseMap: {
      // //     type:'vector',
      // //     features:''
      // //   }
      // // });
      // var infoWin = new qq.maps.InfoWindow({
      //   map: map
      // });
      // this.alarmPointList.result.alarmPointList.forEach((item) =>{
      //   (function(){
      //     var center = new qq.maps.LatLng(item.latitude, item.longitude);
      //     var marker = new qq.maps.Marker({
      //       position: center,
      //       map: map,
      //       animation:qq.maps.MarkerAnimation.DROP
      //     });
      //     //设置Marker自定义图标的属性，size是图标尺寸，该尺寸为显示图标的实际尺寸，origin是切图坐标，该坐标是相对于图片左上角默认为（0,0）的相对像素坐标，anchor是锚点坐标，描述经纬度点对应图标中的位置
      //     var anchor = new qq.maps.Point(15,10),
      //       size = new qq.maps.Size(30, 40),
      //       //origin = item.status === 1 ? new qq.maps.Point(195, 220):new qq.maps.Point(195, 185),
      //       icon = new qq.maps.MarkerImage(
      //         //"http://webmap0.bdimg.com/wolfman/static/common/images/markers_new2_7621a9c.png",
      //         pic,
      //         size,
      //         //origin,
      //         anchor
      //       );
      //     marker.setIcon(icon);
      //     qq.maps.event.addListener(marker, 'click', function() {
      //       localStorage.setItem('alarmPointId',item.pointName);
      //       infoWin.open();
      //       infoWin.setContent(`<div><p class="makerLabel">警报点名称:</p>${item.pointName}</div>
      //                           <div><p class="makerLabel">所属区域Id:</p>${item.areaId}</div>
      //                           <div><a href="/#/realTimeData?alarmPointId=${item._id}" target="_blank">详情</a></div>`);
      //       infoWin.setPosition(center);
      //     });
      //
      //   })();
      // })
    },
    // <div><a href="/alarmPointHome?alarmPointId=${item._id}" target="_blank">详情</a></div>`);
    gotoAlarmPoint(id){
      console.log('hello');
      this.$router.push('/alarmPointView?alarmPointId='+id);
    },
    drawMarker(){

    },
    initWebSocket(){
      if(typeof(WebSocket) === "undefined"){
        alert("您的浏览器不支持WebSocket")
        return false
      }else{
        const wsurl = "ws://localhost:9010/";
        this.websocket = new WebSocket(wsurl);
        this.websocket.onmessage = this.websocketonmessage;
        this.websocket.onopen = this.websocketonopen;
        this.websocket.onerror = this.websocketonerror;
        this.websocket.onclose = this.websocketclose;
      }

    },
    websocketonopen(){ //连接建立之后执行send方法发送数据
    },
    websocketonerror(){//连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e){ //数据接收
      let markerHash = this.markerHash
      // alert(JSON.stringify(JSON.parse(e.data)))
      // alert(Object.keys(JSON.parse(e.data))[0])
      let alarmPointId = Object.keys(JSON.parse(e.data))[0]
      if(this.mapChoose == 'online'){
        if(JSON.parse(e.data)[Object.keys(JSON.parse(e.data))[0]]['online']==true){
          //alert(markerHash[alarmPointId])
          markerHash[alarmPointId].setIcon(online1)
        }else{
          markerHash[alarmPointId].setIcon(online2)
        }
      }
      if(this.mapChoose == 'on'){
        if(JSON.parse(e.data)[Object.keys(JSON.parse(e.data))[0]]['on']==true){
          //alert(markerHash[alarmPointId])
          markerHash[alarmPointId].setIcon(on1)
        }else{
          markerHash[alarmPointId].setIcon(on2)
        }
      }
      if(this.mapChoose == 'elec'){
        if(JSON.parse(e.data)[Object.keys(JSON.parse(e.data))[0]]['CE']==true){
          //alert(markerHash[alarmPointId])
          markerHash[alarmPointId].setIcon(elec1)
        }else{
          markerHash[alarmPointId].setIcon(elec2)
        }
      }
      if(this.mapChoose == 'alarm'){
        if(JSON.parse(e.data)[Object.keys(JSON.parse(e.data))[0]]['alarm']>=90){
          //alert(markerHash[alarmPointId])
          markerHash[alarmPointId].setIcon(alarm1)
        }else{
          markerHash[alarmPointId].setIcon(alarm2)
        }
      }
      if(this.mapChoose == 'return'){
        if(JSON.parse(e.data)[Object.keys(JSON.parse(e.data))[0]]['flag']!=undefined){
          if(JSON.parse(e.data)[Object.keys(JSON.parse(e.data))[0]]['flag']==true){
            //alert(markerHash[alarmPointId])
            if(JSON.parse(e.data)[Object.keys(JSON.parse(e.data))[0]]['stateCode']=='00'){
              markerHash[alarmPointId].setIcon(return1)//回示正常，绿色
            }else{
              markerHash[alarmPointId].setIcon(return3)//回示故障，红色
            }
          }else{
            markerHash[alarmPointId].setIcon(return2)//未回示，黄色
          }
        }

      }
      //this.markerHash[Object.keys(e.data)]
    },
    websocketsend(Data){//数据发送
      this.websocket.send(Data);
    },
    websocketclose(e){  //关闭
    },
  },
  watch:{
    timeRange(newValue, oldValue){
      this.GetMapInformation.params.startTime = newValue[0];
      this.GetMapInformation.params.endTime = newValue[1];
    },
  },
  mounted() {
    this.initMap()
    // this.drawMap(this);
    localStorage.setItem('lastRouter','/map');
    this.getMapInformation();
    this.getCycleTitle()
    this.initWebSocket();
    this.token = this.$store.state.token;
  },
  destroyed () {
    this.websocketclose()
  }

}
</script>
<style scoped>
  .search_in_map span{
    color: white; font-size: 16px
  }
  .search_in_map .el-button{
    margin-top: 20px;
    width: 100%;
  }
  #header{
    width: 100%;
    height: 50px;
    /*background-color: yellow;*/
  }
  #main{
    display: flex;
    display: -moz-flex;
    display: -webkit-flex;
    height: 100%;
  }
  #left{
    width: 300px;
  }
  #right{
    width: 300px;
  }
  #left, #right{
    display: flex;
    flex-direction: column;
  }
  #left div{
    flex: 1;
  }
  #rightFirst, #rightSecond{
    height: 200px;
  }
  #center{
    flex: 1;
    position: relative;
    /*background-color: blue;*/
  }
</style>
<style>
  .makerLabel{
    display: inline-block;
    line-height: 30px;
    width: 100px;
    color: #99a9bf;
  }
</style>
